/* 🤖 this file was generated by svg-to-ts */
export const iccIconNavigateBefore: {
  name: 'navigate_before';
  data: string;
} = {
  name: 'navigate_before',
  data: `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M15.705 7.41 14.295 6l-6 6 6 6 1.41-1.41-4.58-4.59 4.58-4.59Z" fill="currentColor"/></svg>`
};
